import { render, staticRenderFns } from "./DictManage.vue?vue&type=template&id=42f60e8c&scoped=true"
import script from "./DictManage.vue?vue&type=script&lang=js"
export * from "./DictManage.vue?vue&type=script&lang=js"
import style0 from "./DictManage.vue?vue&type=style&index=0&id=42f60e8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f60e8c",
  null
  
)

export default component.exports